export const BuildingMenuType = {
    HOME: 'HOME',
    FLOOR: 'FLOOR',
    SEARCH: 'SEARCH',
    CUSTOM_MENU: 'CUSTOM',
    CUSTOM_MENU_LIST_TYPE: '1',
    CUSTOM_MENU_CARD_TYPE: '2',
    CUSTOM_MENU_TOGGLE_TYPE: '3',
    CUSTOM_MENU_CATEGORY_TYPE: '4',
} as const;

export type BuildingMenuType = (typeof BuildingMenuType)[keyof typeof BuildingMenuType];
